import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { DashboardEconomyChangeOperation } from '@interfaces/dashboard/responses/dashboard-economy-changes.response';
import { VaultDatePipe } from '@shared/pipes/vault-date.pipe';
import { VaultFormatCurrencyPipe } from '@shared/pipes/vault-format-currency.pipe';
import { ECONOMY_CHANGE_CATEGORY_LABELS } from '@src/app/features/dashboard/dashboard-management/pages/economy-history/economy-history.labels';
import { isZeroAmount } from '@src/app/features/dashboard/dashboard-management/pages/economy-history/economy-history.summary';

/**
 * Aba "Por operação" do Histórico da economia (card 3323): antes e depois de cada empréstimo no
 * período, ordenado pela maior variação. Operações sem variação ficam escondidas até a pessoa pedir.
 */
@Component({
  selector: 'app-economy-operations-changes',
  standalone: true,
  imports: [CommonModule, SharedModule, VaultFormatCurrencyPipe, VaultDatePipe],
  templateUrl: './economy-operations-changes.component.html',
  styleUrls: ['./economy-operations-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EconomyOperationsChangesComponent {
  readonly operations = input<DashboardEconomyChangeOperation[]>([]);
  readonly companyNames = input<Record<string, string | null>>({});
  readonly startDate = input<string | null>(null);
  readonly endDate = input<string | null>(null);

  readonly loanSelected = output<string>();

  readonly showAll = signal(false);
  readonly categoryLabels = ECONOMY_CHANGE_CATEGORY_LABELS;

  private readonly sorted = computed(() =>
    [...(this.operations() ?? [])].sort((a, b) => Math.abs(b.variation) - Math.abs(a.variation))
  );

  readonly hiddenCount = computed(
    () => this.sorted().filter(op => isZeroAmount(op.variation)).length
  );

  readonly visible = computed(() =>
    this.showAll() ? this.sorted() : this.sorted().filter(op => !isZeroAmount(op.variation))
  );

  companyName(op: DashboardEconomyChangeOperation): string {
    return this.companyNames()[op.companyId] ?? '';
  }

  signClass(value: number | null): string {
    if (isZeroAmount(value)) return 'is-zero';
    return (value as number) > 0 ? 'is-up' : 'is-down';
  }
}
